module.exports = __webpack_public_path__ + "/login_ui/img/az-4e15c1262dfeadb31b6f036b44fb6ee0.svg";